// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lfx-loading-skeleton-chart',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="loading-skeleton-chart">
      <div class="skeleton-bars">
        @for (bar of skeletonBars; track $index) {
          <div class="skeleton-bar" [style.height.%]="bar"></div>
        }
      </div>
    </div>
  `,
  styles: [`
    .loading-skeleton-chart {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: end;
      justify-content: center;
      padding: var(--lf-spacing-8);
    }

    .skeleton-bars {
      display: flex;
      align-items: end;
      gap: var(--lf-spacing-4);
      height: 100%;
      width: 100%;
    }

    .skeleton-bar {
      flex: 1;
      background: linear-gradient(90deg, 
        var(--lf-color-gray-200) 25%, 
        var(--lf-color-gray-100) 50%, 
        var(--lf-color-gray-200) 75%
      );
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      border-radius: var(--lf-radius-xs);
      min-height: 1px;
    }

    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }
  `]
})
export class LoadingSkeletonChartComponent {
  // Generate random heights for skeleton bars to look more realistic
  protected readonly skeletonBars = LoadingSkeletonChartComponent.generateSkeletonBars(12, 20, 90);

  private static generateSkeletonBars(count: number, min: number, max: number): number[] {
    return Array.from({ length: count }, () =>
      Math.floor(Math.random() * (max - min + 1)) + min
    );
  }
}
